import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M22.108 3.546a6.464 6.464 0 0 0-9.133 0L12 4.52l-.975-.975a6.458 6.458 0 1 0-9.133 9.133l9.374 9.374.755.713L22.108 12.68a6.458 6.458 0 0 0 0-9.133Z" }, null, -1 /* HOISTED */)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }